module.exports = __webpack_public_path__ + "img/aperture.311d7863.png";